// Copyright 2017-2022 @polkadot/ui-shared authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2016 Dan Finlay
import { svg } from "./svg.js";
export function element(size) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'svg';
  var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var elem = svg(type);
  elem.setAttributeNS('', 'x', "".concat(x));
  elem.setAttributeNS('', 'y', "".concat(y));
  elem.setAttributeNS('', 'width', "".concat(size));
  elem.setAttributeNS('', 'height', "".concat(size));
  return elem;
}